import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { DollarSign, Info } from 'react-feather'

// Imports custom
import {
    CustomTableData,
    CustomDropDown,
    TooltipInformation
} from 'common'

const ContractsTable = ({useFetchInit}) => {

    const {
        FetchData,
        Actions
    }= useFetchInit

    const { fetchAllLeaseContracts:{leaseContracts} } = FetchData
    const {handleClickFetchInfoLease, handleClickShowExpenses} = Actions
    
    const columnConfig = [
        { 
            //FIELD PARA TOOLTIP
            headerName: "Info",
            maxWidth: 80,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const {idcontrato, usuario_creo, fecha_creo, usuario_modifico, fecha_modifico} = params.data
                return(
                    <TooltipInformation 
                        idregistro={idcontrato}
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: "contrato_fecha", headerName: "FECHA", minWidth: 150, filter: true },
        { field: "contrato_codigo", headerName: "IDENTIFICADOR", minWidth: 200, filter: true },
        { field: "descripcion_casa", headerName: "DESCRIPCION DE LA CASA", minWidth: 250, filter: true },
        { field: "datos_cliente", headerName: "DATOS DEL CLIENTE", minWidth: 280, filter: true },
        { field: "plazo_meses", headerName: "PLAZO", minWidth: 150, filter: true },
        { 
            field: "contrato_costo_alquiler", headerName: "ALQUILER (Q)", minWidth: 150, filter: true,
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { 
            field: "contrato_check",
            headerName: "CONTRATO",
            minWidth: 250,
            maxWidth: 250,
            filter: true,
            cellStyle: (params) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "left"
            }),
            cellClass: (params) => {
                if(params.value === 'VIGENTE') return 'bg-success';
                if(params.value === 'COBRO JUDICIAL') return 'bg-info';
                if(params.value === 'COBRO EXTRAJUDICIAL') return 'bg-info';
                if(params.value === 'FINALIZACION NORMAL') return 'bg-danger';
                if(params.value === 'FINALIZACION EXTRAORDINARIA') return 'bg-danger';
                if(params.value === 'FINALIZACION POR ABANDONO') return 'bg-danger';
            },
        },
        {
            headerName: "OPCIONES",
            minWidth: 400,
            cellRenderer: (params) => {
                const { idcontrato } = params.data
                return (
                    <CustomDropDown>
                        <MenuItem
                            onClick={() => handleClickFetchInfoLease(idcontrato)}
                        >
                            <ListItemIcon> <Info color="black"/> </ListItemIcon>
                            <ListItemText primary="Información" />
                        </MenuItem>
                        <MenuItem
                            onClick={() => handleClickShowExpenses(idcontrato)}
                        >
                            <ListItemIcon> <DollarSign color="black"/> </ListItemIcon>
                            <ListItemText primary="Gastos Extras" />
                        </MenuItem>
                    </CustomDropDown>
                )
            }
        },
    ]

    return (
        //ESTRUCTURA PARA INCLUIR CAJA DE BUSQUEDA
        <div className='content'>
            <CustomTableData 
                rowConfig={leaseContracts}
                columnConfig={columnConfig}
            />
        </div>
    )

}

export {
    ContractsTable
}